import * as types from "../actions/actionTypes";
import { CurrentMentorsActions } from "../actions/currentClientActions";
import initialState from "./initialState";


export default function liveSwitchTokenReducer(
    state = initialState.liveSwitchToken,
    action: CurrentMentorsActions
): string | null {
    switch (action.type) {
        case types.GET_LIVESWITCH_TOKEN_SUCCESS:
            return action.result.token;
        default:
            return state;
    }
}
